import { ELEMENT_TYPE_PLURAL_NAMES } from "lib/constants";
import { getElementIcon } from "views/components/Editor/sidebar/tabs/layers/getElementIcon";
import ShapesIcon from "views/components/icons/ShapesIcon";

const SELECT_ALL_ICON_OVERRIDES = {
  vector: ShapesIcon
};

/**
 * Determines whether the "Select All [Type]" option should be shown
 * in the context menu, and returns the relevant display info.
 *
 * @param {Array<{itemId: string}>} selectedItems - Currently selected items
 * @param {object} designData - The design data containing elements and pages
 * @param {string|null|undefined} currentPageId - The current page ID
 * @returns {{ selectAllType: string|null, selectAllCount: number, showSelectAll: boolean, SelectAllIcon: React.ComponentType|null, selectAllLabel: string|null }}
 */
export const getSelectAllTypeInfo = (
  selectedItems,
  designData,
  currentPageId
) => {
  let selectAllType = null;
  let selectAllCount = 0;

  if (selectedItems.length >= 1) {
    const selectedTypes = selectedItems.map(
      item => designData.elements[item.itemId]?.type
    );
    const allSameType = selectedTypes.every(t => t === selectedTypes[0]);

    if (allSameType && selectedTypes[0]) {
      selectAllType = selectedTypes[0];
      const page = currentPageId && designData.pages[currentPageId];
      if (page && page.elementsOrder) {
        selectAllCount = page.elementsOrder.reduce((count, elementId) => {
          const element = designData.elements[elementId];
          if (!element) return count;
          if (element.type === selectAllType) return count + 1;
          if (element.type === "group" && element.elementsOrder) {
            return (
              count +
              element.elementsOrder.filter(childId => {
                const child = designData.elements[childId];
                return child && child.type === selectAllType;
              }).length
            );
          }
          return count;
        }, 0);
      }
    }
  }

  const showSelectAll = selectAllType && selectAllCount > 1;
  const SelectAllIcon = showSelectAll
    ? SELECT_ALL_ICON_OVERRIDES[selectAllType] || getElementIcon(selectAllType)
    : null;
  const selectAllLabel = showSelectAll
    ? `Select All ${ELEMENT_TYPE_PLURAL_NAMES[selectAllType] || selectAllType}`
    : null;

  return {
    selectAllType,
    selectAllCount,
    showSelectAll,
    SelectAllIcon,
    selectAllLabel
  };
};
